import { createHttpEndpoint } from '../utils'

import type { CreateRecyclingResponse } from './recycling.types'

/**
 * Create recycling
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/recycling-api/definition#/default/create_recycling}
 */
export const createRecycling = createHttpEndpoint<CreateRecyclingResponse>({
  method: 'POST',
  operationId: 'createRecycling',
  path: '/recycling/api/v1/recyclings',
})
